import { render, staticRenderFns } from "./edit-inv-quantity-dialog.vue?vue&type=template&id=0f151b26&"
import script from "./edit-inv-quantity-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-inv-quantity-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VLayout})
